import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ---- 401 handling ----
// If any authed request returns 401, we broadcast a `sl:session-expired`
// event that AuthContext listens for. This keeps the React user state in
// sync with the real server session so the UI doesn't show "logged in"
// while the dashboard silently returns empty because the cookie is gone.
//
// We suppress the broadcast for endpoints that are legitimately anonymous
// (e.g. GET /auth/me on first page load) — a 401 there just means "not
// signed in", not "session died".
const SILENT_401_PATHS = ["/auth/me"];

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !SILENT_401_PATHS.some((p) => url.endsWith(p))) {
      try {
        window.dispatchEvent(new CustomEvent("sl:session-expired"));
      } catch {
        /* SSR / non-browser env — noop */
      }
    }
    return Promise.reject(err);
  }
);

export default api;
